import { render } from "./dropdown.vue?vue&type=template&id=b2e1516e"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"

import "./dropdown.vue?vue&type=style&index=0&id=b2e1516e&lang=scss"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/AI_Playground/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__